module.exports = __webpack_public_path__ + "img/marker-flex-moving-NW.png";